<style src="./Input.scss" lang="scss"></style>

<template lang="pug">
  -
    attrs = {
      '@input': 'onInput',
      'v-model': 'fieldValue',
      'v-shortkey.avoid': true,
      'ref': 'input',
      ':type': 'fieldType',
      ':name': 'name',
      ':placeholder': 'placeholder',
      ':required': 'required',
      ':minlength': 'minlength',
      ':min': 'min',
      ':max': 'max',
      ':pattern': 'pattern',
      ':title': 'title',
    }

  .input(
    :class='classList'
  )
    the-mask.input__field(
      v-if='mask'
      :mask='mask'
      :masked='true'
    )&attributes(attrs)

    input.input__field(
      v-else
    )&attributes(attrs)

    button.input__hint-toggle(
      @click='toggleHint'
      :class='hintVisible && "is-active"'
      v-if='hint'
      type='button'
    )
      Icon(
        name='question'
      )

    button.input__password-toggle(
      @click='togglePasswordVisible'
      type='button'
      v-if='type === "password"'
    )
      Icon(
        name='eye'
      )

    .input__hint(
      v-if='hint && hintVisible'
      v-click-outside='hideHint'
    )
      Hint(
        :content='hint'
        :type='"form"'
      )
</template>

<script>
import Icon from "@/components/Icon/Icon";
import Hint from "@/components/Hint/Hint";
import { TheMask } from "vue-the-mask";

export default {
  props: {
    mask: {
      type: [String, Number, Array]
    },
    value: {
      default: "",
      type: [String, Number]
    },
    type: {
      default: "text",
      type: String
    },
    hint: {
      default: "",
      type: String
    },
    name: {
      default: "",
      type: String
    },
    pattern: null,
    title: {
      default: "",
      type: String
    },
    placeholder: {
      default: "",
      type: String
    },
    required: {
      default: false,
      type: Boolean
    },
    minlength: {
      type: Number
    },
    invalid: {
      default: false,
      type: Boolean
    },
    setFocus: {
      default: false,
      type: Boolean
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    }
  },
  data() {
    return {
      hintVisible: false,
      fieldValue: this.value,
      fieldType: this.type
    };
  },
  computed: {
    classList() {
      return {
        "is-password": this.type === "password",
        "is-visible": this.type === "password" && this.fieldType === "text",
        "is-invalid": this.invalid,
        "has-hint": this.hint
      };
    }
  },
  components: { TheMask, Icon, Hint },
  methods: {
    onInput() {
      this.$emit("input", this.fieldValue);
    },
    togglePasswordVisible() {
      this.fieldType = this.fieldType === "password" ? "text" : "password";
    },
    setValidity(text) {
      this.$refs.input.setCustomValidity(text);
    },
    toggleHint() {
      this.hintVisible = !this.hintVisible;
    },
    hideHint() {
      this.hintVisible = false;
    }
  },
  watch: {
    value(value) {
      this.fieldValue = value;
    }
  },
  mounted() {
    if (this.setFocus) {
      this.$refs.input.focus();
    }
  }
};
</script>
